import { apiService } from "api/apiService";
import type { ActivityResource } from "api/generated";
import { teacherStudentActivityFromDto } from "portfolio/api/mappers";
import type { TeacherStudentActivity } from "portfolio/types";

export const fetchStudentActivity = async (
  studentId: number,
  activityId: number,
): Promise<TeacherStudentActivity> => {
  const {
    data: { data },
  } = await apiService.get<{ data: ActivityResource }>(
    `api/portfolio/students/${studentId}/activities/${activityId}`,
  );

  return teacherStudentActivityFromDto(data);
};
